import Vue from 'vue';
import CalculatorTabs from '~arithmetic/components/calculator-tabs.vue';
import CalculatorStats from '~arithmetic/components/calculator-stats.vue';
import CalculatorDiscount from '~arithmetic/components/calculator-discount.vue';
import Calculator from '~arithmetic/components/calculator.vue';

Vue.component('sf-calculator', Calculator);
Vue.component('sf-calculator-tabs', CalculatorTabs);
Vue.component('sf-calculator-stats', CalculatorStats);
Vue.component('sf-calculator-discount', CalculatorDiscount);
